// extracted by mini-css-extract-plugin
export default {"container":"Services_container__Ff15U","header":"Services_header__svCos","title":"Services_title__D1S3M","subtitle":"Services_subtitle__mxvKh"};